import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PromoProvider } from '../../providers/promo/promo';
import { TranslateService } from '@ngx-translate/core';
import { NumberFormatter } from '../../pipes/currency-pipe';

@Component({
  selector: 'rmt-promo-row-new',
  templateUrl: 'rmt-promo-row-new.html'
})
export class RmtPromoRowNewComponent {
  @Input() isPromoValid;
  @Input() errorPromo;
  @Input() promoEngineError;
  @Input() fromSummaryPage: boolean = false;
  @Input() showAddButton: boolean = false;
  @Input() promo;
  @Input() order;
  canShowDelete:boolean = true;
  promoName;

  @Output() showPromo = new EventEmitter<number>();
  @Output() removePromo = new EventEmitter<number>();

  constructor(private promoProvider: PromoProvider,
              private currencyFormatter: NumberFormatter,
              private translate: TranslateService,) {
  }

  get isStagedIneligible(): boolean {
    return this.promoProvider.isRafStagedIneligible(this.promoEngineError);
  }

  getPromoSuccess() {
    if (!this.promo)
      return '';

    this.promoName = this.promoProvider.getPromoName(this.promo);
    let promoSuccess = '<span class="promo-name">' + this.promoName +'</span> ';
    if (this.promo.isPromoEngine && (this.promo.effect || this.promo.hideCode)){
      if (this.promo.hideCode && this.promo.effect && this.promo.effect.length > 0)
        promoSuccess = '<span class="promo-name">' + this.promo.effect +'</span> '
    }
    if(this.promoProvider.isPromoTypeReferral(this.promo) && this.promo.isAdvocate === false){
      this.canShowDelete = false;
    }
    return promoSuccess;
  }

  getPromoSuccessAmount() {
    let promoSuccessAmount = '';

    if (this.order && this.order.promoAmount == 0 && this.order.originalCustomerFee && this.order.originalCustomerFee > 0) {
      let discount = Math.abs(this.order.customerFee - this.order.originalCustomerFee);
      if (!discount)
        discount = 0;
      const result = this.currencyFormatter.transform(discount, this.order.currencyFrom, false, true);
      promoSuccessAmount += '-<span class="promo-name">' + result + ' ' + this.order.currencyFrom + '</span>';
    }
    if(this.order && this.isPromoBonusAmount()) {
      let amount = this.order.promoAmount;
      promoSuccessAmount += '+<span class="promo-name">' + amount + ' ' + this.order.currencyFrom + '</span>';
    }

    return promoSuccessAmount;
  }

  isPromoBonusAmount() {
    return this.promo && this.order.promoAmount && this.order.promoAmount !== 0;
  }

  getAmountPromoHint() {
    let text: string;
    if (this.promo && this.order) {
      let amount = this.order.promoAmount;
      if (!amount)
        amount = 0;
      text = '+' + this.currencyFormatter.transform(amount, this.order.currencyFrom) + ' ' + this.order.currencyFrom;
    }
    return text;
  }

  getPromoInvalid() {
    if(!this.promoName)
      this.setPromoNameOnInvalid();

    const stagedClass = this.isStagedIneligible ? ' promo-name-invalid--staged' : '';
    const promoInvalid = '<span class="promo-name promo-name-invalid' + stagedClass + '">' + this.promoName +'</span>';
    return promoInvalid;
  }

  setPromoNameOnInvalid() {
    if (!this.promoName && this.promoEngineError)
      this.promoName = this.promoEngineError.code;
    if (!this.promoName && this.promo)
      this.promoName = this.promo.PromoCode;
    // code is null for referrals bound at registration; promoName goes straight into markup.
    if (!this.promoName)
      this.promoName = '';
  }

  getPromoHintInvalid() {
    if(!this.promoName)
      this.setPromoNameOnInvalid();

    const promoInvalid = this.promoProvider.getPromoErrorMessage(this.promoEngineError);
    // let promoInvalid = this.translate.instant('page.promotionsPage.promoNotApplicableAlert', {class: 'promo-name-effect-error', promoCode: this.promoName });
    // if(effectLabel) {
    //   promoInvalid += ' - ' + this.promoEngineError.effect;
    // }

    return promoInvalid;
  }

  clickShowPromo() {
    this.showPromo.emit();
  }

  clickRemovePromo(ev) {
    this.removePromo.emit();
    ev.stopPropagation();
    ev.preventDefault();
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-promo-row-new/rmt-promo-row-new.ts